const vendasRoutes = [
  {
    path: '/vendas/dashboard',
    name: 'vendas.dashboard',
    component: () => import('../views/vendas/Dashboard.vue'),
  },
  {
    path: '/vendas/talonarionf',
    name: 'vendas.talonarionf',
    component: () => import('../views/vendas/TalonarioNF.vue'),
  },
  {
    path: '/vendas/pedido',
    name: 'vendas.pedido',
    component: () => import('../views/vendas/Pedido.vue'),
  },
  {
    path: '/vendas/mapa-sucesso-cliente',
    name: 'venda.faturamentoEmpresas',
    component: () => import('../views/vendas/MapaSucessoCliente.vue'),
  },
  {
    path: '/vendas/consulta-notas-sem-protocolo',
    name: 'venda.consulta-notas-sem-protocolo',
    component: () => import('../views/vendas/ConsultaNotasSemProtocolo.vue'),
  },
];

export default vendasRoutes;
